import { z } from "zod";
import { MAX_FILE_SIZE } from "@/features/jobs/configs/constants";

export const fileSchema = z.object({
  file: z
    .custom<File>((file) => file instanceof File, { message: "Veuillez sélectionner un fichier" })
    .refine((file) => file.size <= MAX_FILE_SIZE, { message: `Le fichier est trop volumineux. Taille maximale autorisée : ${MAX_FILE_SIZE / (1024 * 1024)}Mo` })
    .refine(
      (file) => {
        const validTypes = [".xlsx", ".xls"];
        return validTypes.some((type) => file.name.toLowerCase().endsWith(type));
      },
      { message: "Le fichier doit être au format Excel (.xlsx ou .xls)" },
    ),
});

export type FileFormData = z.infer<typeof fileSchema>;
